/* eslint-disable no-unused-vars */
import { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../Sidebar';
import { ArrowLeft, Download, Filter } from 'lucide-react';
import { getEmpresa } from '../../../utils/empresas';

const PERGUNTAS = [
    { id: 'P_1',  bloco: 'Jornada, Descanso e Organização do Trabalho',         texto: 'Você consegue fazer suas pausas e descanso normalmente.' },
    { id: 'P_2',  bloco: 'Jornada, Descanso e Organização do Trabalho',         texto: 'Você consegue terminar suas tarefas dentro do horário de trabalho.' },
    { id: 'P_3',  bloco: 'Jornada, Descanso e Organização do Trabalho',         texto: 'A quantidade de trabalho durante o dia é adequada.' },
    { id: 'P_4',  bloco: 'Metas e Dinâmica de Resultados',                      texto: 'Você entende o que precisa fazer no seu trabalho.' },
    { id: 'P_5',  bloco: 'Metas e Dinâmica de Resultados',                      texto: 'O ritmo de trabalho é compatível com minha capacidade.' },
    { id: 'P_6',  bloco: 'Metas e Dinâmica de Resultados',                      texto: 'Quando surge um problema, alguém orienta você sobre o que fazer.' },
    { id: 'P_7',  bloco: 'Relações Interpessoais e Respeito',                   texto: 'Tenho um bom relacionamento com meus colegas de trabalho.' },
    { id: 'P_8',  bloco: 'Relações Interpessoais e Respeito',                   texto: 'Os desentendimentos no trabalho são resolvidos com calma.' },
    { id: 'P_9',  bloco: 'Relações Interpessoais e Respeito',                   texto: 'O ambiente de trabalho é respeitoso.' },
    { id: 'P_10', bloco: 'Comunicação e Questões do Dia a Dia',                 texto: 'As orientações que você recebe são claras.' },
    { id: 'P_11', bloco: 'Comunicação e Questões do Dia a Dia',                 texto: 'Quando há mudanças no trabalho, você é avisado com antecedência.' },
    { id: 'P_12', bloco: 'Comunicação e Questões do Dia a Dia',                 texto: 'Quando você tem dúvida, consegue receber explicações.' },
    { id: 'P_13', bloco: 'Ética, Conduta e Critérios Organizacionais',          texto: 'As decisões no trabalho são tomadas de forma adequada.' },
    { id: 'P_14', bloco: 'Apoio, Liderança e Condições para Execução',          texto: 'Seus líderes são acessíveis quando você precisa falar.' },
    { id: 'P_15', bloco: 'Apoio, Liderança e Condições para Execução',          texto: 'Quando você tem dificuldade, recebe apoio.' },
    { id: 'P_16', bloco: 'Apoio, Liderança e Condições para Execução',          texto: 'Suas responsabilidades são explicadas com clareza.' },
    { id: 'P_17', bloco: 'Reconhecimento e Percepção de Justiça',               texto: 'Seu trabalho é reconhecido quando você faz bem feito.' },
    { id: 'P_18', bloco: 'Reconhecimento e Percepção de Justiça',               texto: 'As regras são aplicadas da mesma forma para todos.' },
    { id: 'P_19', bloco: 'Reconhecimento e Percepção de Justiça',               texto: 'Você é tratado com respeito pela empresa.' },
    { id: 'P_20', bloco: 'Ambiente e Estrutura de Trabalho',                    texto: 'O local onde você trabalha permite fazer suas tarefas com segurança.' },
    { id: 'P_21', bloco: 'Ambiente e Estrutura de Trabalho',                    texto: 'Os equipamentos necessários para o trabalho estão disponíveis.' },
    { id: 'P_22', bloco: 'Ambiente e Estrutura de Trabalho',                    texto: 'As orientações de segurança são fáceis de entender.' },
    { id: 'P_23', bloco: 'Percepção de Bem-Estar na Rotina Laboral',            texto: 'Você consegue dividir seu tempo entre trabalho e vida pessoal.' },
    { id: 'P_24', bloco: 'Percepção de Bem-Estar na Rotina Laboral',            texto: 'Você inicia o dia de trabalho com disposição.' },
    { id: 'P_25', bloco: 'Apoio Institucional e Prevenção',                     texto: 'Você sabe como comunicar problemas no trabalho.' },
    { id: 'P_26', bloco: 'Apoio Institucional e Prevenção',                     texto: 'Você se sente à vontade para relatar situações difíceis.' },
    { id: 'P_27', bloco: 'Apoio Institucional e Prevenção',                     texto: 'A empresa demonstra preocupação com o bem-estar dos funcionários.' },
];

const OPCOES_ESCALA = ['Sempre', 'Quase sempre', 'Às vezes', 'Raramente', 'Nunca'];
const BLOCOS_UNICOS = [...new Set(PERGUNTAS.map(p => p.bloco))];
const PESO = { 'Sempre': 5, 'Quase sempre': 4, 'Às vezes': 3, 'Raramente': 2, 'Nunca': 1 };
const COR_OPCAO = { 'Sempre': '#10b981', 'Quase sempre': '#34d399', 'Às vezes': '#fbbf24', 'Raramente': '#f97316', 'Nunca': '#ef4444' };
// COR_CELULA mantida para referência, mas a tabela agora usará corScore

const calcularDistribuicao = (dados, perguntaId) => {
    const contagem = {};
    OPCOES_ESCALA.forEach(o => { contagem[o] = 0; });
    dados.forEach(row => { if (row[perguntaId] && contagem[row[perguntaId]] !== undefined) contagem[row[perguntaId]]++; });
    const total = dados.length;
    return OPCOES_ESCALA.map(opcao => ({
        opcao, qtd: contagem[opcao] || 0,
        pct: total > 0 ? parseFloat(((contagem[opcao] || 0) / total * 100).toFixed(1)) : 0
    }));
};

const calcularScore = (dados, perguntaId) => {
    const validos = dados.filter(r => r[perguntaId] && PESO[r[perguntaId]] !== undefined);
    if (validos.length === 0) return null;
    return parseFloat((validos.reduce((acc, r) => acc + PESO[r[perguntaId]], 0) / validos.length).toFixed(2));
};

const corScore = (score) => {
    if (score === null) return '#94a3b8';
    if (score >= 4.0) return '#10b981';
    if (score >= 3.0) return '#f59e0b';
    return '#ef4444';
};

function PesquisaClimaRelatorio({ embedded = false }) {
    const navigate = useNavigate();
    const [isCollapsed, setIsCollapsed] = useState(window.innerWidth <= 768);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [respostas, setRespostas] = useState([]);
    const [filtradas, setFiltradas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filterLoja, setFilterLoja] = useState('');
    const [filterEmpresa, setFilterEmpresa] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [filterBloco, setFilterBloco] = useState('');
    const [agruparPor, setAgruparPor] = useState('loja'); // 'loja' | 'empresa'
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 50;

    const getMarginLeft = () => {
        if (window.innerWidth <= 480) return isCollapsed ? '60px' : '0px';
        return isCollapsed ? '100px' : '260px';
    };

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 768;
            setIsMobile(mobile);
            if (mobile) setIsCollapsed(true);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const fetchRespostas = async () => {
            try {
                const token = localStorage.getItem('authToken');
                const res = await fetch('/api/forms-rh/pesquisaclima/respostas', { headers: { 'Authorization': `Bearer ${token}` } });
                if (!res.ok) throw new Error('Falha ao carregar respostas.');
                const data = await res.json();
                setRespostas(data);
                setFiltradas(data);
            } catch (err) { setError(err.message); } finally { setLoading(false); }
        };
        fetchRespostas();
    }, []);

    useEffect(() => {
        let result = [...respostas];
        if (filterEmpresa) result = result.filter(r => getEmpresa(r.LOJA) === filterEmpresa);
        if (filterLoja) result = result.filter(r => r.LOJA === filterLoja);
        if (startDate) result = result.filter(r => r.TIMESTAMP >= startDate);
        if (endDate) result = result.filter(r => r.TIMESTAMP <= endDate + ' 23:59:59');
        setFiltradas(result);
        setCurrentPage(1);
    }, [filterEmpresa, filterLoja, startDate, endDate, respostas]);

    // Volta à primeira página ao alternar entre visão por loja e por empresa
    useEffect(() => { setCurrentPage(1); }, [agruparPor]);

    const porEmpresaAtivo = agruparPor === 'empresa';

    // Agrupa as respostas e calcula a média por grupo (loja ou empresa).
    // Na visão por empresa, o score de cada pergunta usa o pool de TODAS as respostas
    // das lojas da empresa (calcularScore já faz a média sobre o conjunto inteiro).
    const mediasPorGrupo = useMemo(() => {
        const agrupado = {};

        filtradas.forEach(resposta => {
            const chave = porEmpresaAtivo
                ? getEmpresa(resposta.LOJA)
                : (resposta.LOJA || 'Não informada');
            if (!agrupado[chave]) agrupado[chave] = [];
            agrupado[chave].push(resposta);
        });

        const resultado = Object.keys(agrupado).map(chave => {
            const respostasDoGrupo = agrupado[chave];
            const objeto = {
                GRUPO: chave,
                EMPRESA: porEmpresaAtivo ? chave : getEmpresa(chave),
                TOTAL_RESPOSTAS: respostasDoGrupo.length
            };

            PERGUNTAS.forEach(p => {
                objeto[p.id] = calcularScore(respostasDoGrupo, p.id);
            });

            return objeto;
        });

        return resultado.sort((a, b) => a.GRUPO.localeCompare(b.GRUPO));
    }, [filtradas, porEmpresaAtivo]);

    const exportarCSV = () => {
        // Mantive a exportação dos dados brutos (individuais) para auditoria.
        const header = ['Empresa', 'Loja', 'Data Resposta', ...PERGUNTAS.map((_, i) => `Q${i + 1}`)].join(';');
        const linhas = filtradas.map(r => [
            getEmpresa(r.LOJA),
            r.LOJA,
            r.DATA_RESPOSTA ? new Date(r.DATA_RESPOSTA).toLocaleDateString('pt-BR') : '',
            ...PERGUNTAS.map(p => r[p.id] || '')
        ].join(';'));
        const blob = new Blob(['\uFEFF' + [header, ...linhas].join('\n')], { type: 'text/csv;charset=utf-8;' });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = `pesquisa_clima_${new Date().toISOString().slice(0, 10)}.csv`;
        a.click();
    };

    const lojas = [...new Set(respostas.map(r => r.LOJA))].sort();
    const empresas = [...new Set(respostas.map(r => getEmpresa(r.LOJA)))].sort();
    // No filtro de loja, mostra só as lojas da empresa selecionada (se houver)
    const lojasFiltradas = filterEmpresa ? lojas.filter(l => getEmpresa(l) === filterEmpresa) : lojas;
    
    // A paginação observa o array agrupado (por loja ou por empresa)
    const totalPages = Math.ceil(mediasPorGrupo.length / itemsPerPage);
    const paginados = mediasPorGrupo.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    const perguntasFiltradas = filterBloco ? PERGUNTAS.filter(p => p.bloco === filterBloco) : PERGUNTAS;

    const inputStyle = { padding: '9px 12px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '13px', backgroundColor: '#fff', color: '#334155', outline: 'none' };
    const cardStyle = { backgroundColor: '#fff', borderRadius: '12px', border: '1px solid #e2e8f0', padding: '20px', marginBottom: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' };

    return (
        <div style={embedded ? { width: '100%' } : { display: 'flex', minHeight: '100vh', backgroundColor: '#f1f5f9', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
            {!embedded && <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}
            <main style={{ flex: 1, marginLeft: embedded ? 0 : getMarginLeft(), padding: isMobile ? '16px' : '32px', transition: 'margin-left 0.3s ease', minWidth: 0 }}>

                {!embedded && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px', flexWrap: 'wrap' }}>
                        <button onClick={() => navigate('/rh')} style={{ padding: '8px 14px', borderRadius: '8px', border: '1px solid #e2e8f0', backgroundColor: '#fff', color: '#475569', fontSize: '14px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <ArrowLeft size={16} /> Voltar
                        </button>
                        <div style={{ flex: 1 }}>
                            <h1 style={{ fontSize: isMobile ? '18px' : '22px', fontWeight: 'bold', color: '#0f172a', margin: 0 }}>Relatório — Pesquisa de Clima</h1>
                            <p style={{ fontSize: '13px', color: '#64748b', margin: 0 }}>{filtradas.length} resposta(s) no período selecionado</p>
                        </div>
                        <button onClick={exportarCSV} style={{ padding: '10px 18px', borderRadius: '8px', backgroundColor: '#0f172a', color: '#fff', border: 'none', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <Download size={14} /> Exportar CSV (Dados Brutos)
                        </button>
                    </div>
                )}

                {loading ? (
                    <div style={{ textAlign: 'center', padding: '60px', color: '#64748b' }}>Carregando respostas...</div>
                ) : error ? (
                    <div style={{ backgroundColor: '#fef2f2', color: '#991b1b', padding: '16px', borderRadius: '8px' }}>{error}</div>
                ) : (
                    <>
                        {/* Filtros */}
                        <div style={{ ...cardStyle, padding: '16px', display: 'flex', flexWrap: 'wrap', gap: '12px', alignItems: 'center' }}>
                            <Filter size={16} style={{ color: '#94a3b8' }} />
                            <select
                                value={filterEmpresa}
                                onChange={e => { setFilterEmpresa(e.target.value); setFilterLoja(''); }}
                                style={inputStyle}
                            >
                                <option value="">Todas as Empresas</option>
                                {empresas.map(emp => <option key={emp} value={emp}>{emp}</option>)}
                            </select>
                            <select value={filterLoja} onChange={e => setFilterLoja(e.target.value)} style={inputStyle}>
                                <option value="">Todas as Lojas</option>
                                {lojasFiltradas.map(l => <option key={l} value={l}>{l}</option>)}
                            </select>
                            <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} style={inputStyle} />
                            <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} style={inputStyle} />
                            <select value={filterBloco} onChange={e => setFilterBloco(e.target.value)} style={{ ...inputStyle, minWidth: '180px' }}>
                                <option value="">Todos os Blocos</option>
                                {BLOCOS_UNICOS.map(b => <option key={b} value={b}>{b}</option>)}
                            </select>
                            <button onClick={() => { setFilterEmpresa(''); setFilterLoja(''); setStartDate(''); setEndDate(''); setFilterBloco(''); }} style={{ ...inputStyle, cursor: 'pointer', color: '#7c3aed', backgroundColor: '#f3f0ff', border: '1px solid #ddd6fe' }}>
                                Limpar
                            </button>

                            {/* Alternância de visualização: por loja / por empresa */}
                            <div style={{ display: 'flex', border: '1px solid #cbd5e1', borderRadius: '8px', overflow: 'hidden', marginLeft: 'auto' }}>
                                {[{ k: 'loja', label: 'Por Loja' }, { k: 'empresa', label: 'Por Empresa' }].map(opt => (
                                    <button
                                        key={opt.k}
                                        onClick={() => setAgruparPor(opt.k)}
                                        style={{
                                            padding: '9px 16px', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold',
                                            backgroundColor: agruparPor === opt.k ? '#7c3aed' : '#fff',
                                            color: agruparPor === opt.k ? '#fff' : '#475569'
                                        }}
                                    >
                                        {opt.label}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Resumo por pergunta (Mantido intacto) */}
                        {filtradas.length > 0 && (
                            <div style={cardStyle}>
                                <h2 style={{ fontSize: '16px', fontWeight: 'bold', color: '#0f172a', marginBottom: '20px' }}>Resumo por Pergunta</h2>
                                {(() => {
                                    const blocos = {};
                                    perguntasFiltradas.forEach(p => {
                                        if (!blocos[p.bloco]) blocos[p.bloco] = [];
                                        blocos[p.bloco].push(p);
                                    });
                                    return Object.entries(blocos).map(([bloco, perguntas]) => (
                                        <div key={bloco} style={{ marginBottom: '28px' }}>
                                            <h3 style={{ fontSize: '12px', fontWeight: '700', color: '#7c3aed', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '14px', paddingBottom: '6px', borderBottom: '2px solid #ede9fe' }}>
                                                {bloco}
                                            </h3>
                                            {perguntas.map((pergunta, idx) => {
                                                const numGlobal = PERGUNTAS.findIndex(p => p.id === pergunta.id) + 1;
                                                const dist = calcularDistribuicao(filtradas, pergunta.id);
                                                const score = calcularScore(filtradas, pergunta.id);
                                                return (
                                                    <div key={pergunta.id} style={{ marginBottom: '20px', paddingBottom: '20px', borderBottom: idx < perguntas.length - 1 ? '1px solid #f1f5f9' : 'none' }}>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px', gap: '10px', flexWrap: 'wrap' }}>
                                                            <span style={{ fontSize: '13px', color: '#334155', flex: 1 }}>
                                                                <strong style={{ color: '#7c3aed' }}>{numGlobal}.</strong> {pergunta.texto}
                                                            </span>
                                                            {score !== null && (
                                                                <span style={{ fontSize: '13px', fontWeight: 'bold', color: corScore(score), backgroundColor: corScore(score) + '22', padding: '3px 10px', borderRadius: '99px', whiteSpace: 'nowrap' }}>
                                                                    Score: {score}/5
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                            {dist.map(({ opcao, qtd, pct }) => (
                                                                <div key={opcao} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                    <span style={{ fontSize: '11px', color: '#64748b', width: '90px', flexShrink: 0 }}>{opcao}</span>
                                                                    <div style={{ flex: 1, backgroundColor: '#f1f5f9', borderRadius: '4px', height: '16px', overflow: 'hidden' }}>
                                                                        <div style={{ width: `${pct}%`, height: '100%', backgroundColor: COR_OPCAO[opcao], borderRadius: '4px', minWidth: qtd > 0 ? '4px' : '0' }} />
                                                                    </div>
                                                                    <span style={{ fontSize: '11px', color: '#475569', width: '64px', textAlign: 'right', flexShrink: 0 }}>{qtd} ({pct}%)</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ));
                                })()}
                            </div>
                        )}

                        {/* Nova Tabela de Médias por Loja */}
                        <div style={{ ...cardStyle, padding: 0, overflow: 'hidden' }}>
                            <div style={{ padding: '16px 20px', borderBottom: '1px solid #e2e8f0' }}>
                                <h2 style={{ fontSize: '15px', fontWeight: 'bold', color: '#0f172a', margin: 0 }}>Médias por {porEmpresaAtivo ? 'Empresa' : 'Loja'}</h2>
                            </div>
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                                            <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: '600', color: '#475569', whiteSpace: 'nowrap' }}>{porEmpresaAtivo ? 'Empresa' : 'Loja'}</th>
                                            {!porEmpresaAtivo && (
                                                <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: '600', color: '#475569', whiteSpace: 'nowrap' }}>Empresa</th>
                                            )}
                                            <th style={{ padding: '10px 12px', textAlign: 'center', fontWeight: '600', color: '#475569', whiteSpace: 'nowrap' }}>Qtd. Respostas</th>
                                            {PERGUNTAS.map((_, i) => (
                                                <th key={i} style={{ padding: '10px 8px', textAlign: 'center', fontWeight: '600', color: '#475569', whiteSpace: 'nowrap' }}>Q{i + 1}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paginados.length === 0 ? (
                                            <tr><td colSpan={porEmpresaAtivo ? 29 : 30} style={{ padding: '40px', textAlign: 'center', color: '#94a3b8' }}>Nenhum registro encontrado.</td></tr>
                                        ) : paginados.map((row, idx) => (
                                            <tr key={row.GRUPO} style={{ borderBottom: '1px solid #f1f5f9', backgroundColor: idx % 2 === 0 ? '#fff' : '#fafafa' }}>
                                                <td style={{ padding: '9px 12px', fontWeight: '600', color: '#334155', whiteSpace: 'nowrap' }}>{row.GRUPO}</td>
                                                {!porEmpresaAtivo && (
                                                    <td style={{ padding: '9px 12px', color: '#64748b', textAlign: 'center', whiteSpace: 'nowrap' }}>{row.EMPRESA}</td>
                                                )}
                                                <td style={{ padding: '9px 12px', color: '#64748b', textAlign: 'center', whiteSpace: 'nowrap' }}>
                                                    {row.TOTAL_RESPOSTAS}
                                                </td>
                                                {PERGUNTAS.map(p => {
                                                    const score = row[p.id];
                                                    // Aplica transparência na cor de fundo adicionando '22' no hexadecimal
                                                    const bgColor = score ? corScore(score) + '22' : 'transparent';
                                                    const textColor = score ? corScore(score) : '#94a3b8';
                                                    
                                                    return (
                                                        <td key={p.id} title={p.texto} style={{ padding: '9px 8px', textAlign: 'center', backgroundColor: bgColor }}>
                                                            <span style={{ fontSize: '11px', fontWeight: 'bold', color: textColor }}>
                                                                {score !== null ? score : '—'}
                                                            </span>
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            {totalPages > 1 && (
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', padding: '16px', borderTop: '1px solid #e2e8f0' }}>
                                    <button onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1} style={{ ...inputStyle, cursor: currentPage === 1 ? 'not-allowed' : 'pointer', padding: '6px 12px' }}>← Anterior</button>
                                    <span style={{ fontSize: '13px', color: '#64748b' }}>Página {currentPage} de {totalPages}</span>
                                    <button onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages} style={{ ...inputStyle, cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', padding: '6px 12px' }}>Próxima →</button>
                                </div>
                            )}
                        </div>

                        {/* Legenda Atualizada */}
                        <div style={{ ...cardStyle, padding: '14px 20px', display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'center' }}>
                            <span style={{ fontSize: '12px', color: '#64748b', fontWeight: '600' }}>Legenda da Tabela (Média):</span>
                            <span style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '11px', color: '#475569' }}>
                                <span style={{ display: 'inline-block', width: '14px', height: '14px', backgroundColor: '#10b98122', border: '1px solid #10b981', borderRadius: '3px' }} />
                                Score ≥ 4.0
                            </span>
                            <span style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '11px', color: '#475569' }}>
                                <span style={{ display: 'inline-block', width: '14px', height: '14px', backgroundColor: '#f59e0b22', border: '1px solid #f59e0b', borderRadius: '3px' }} />
                                Score 3.0–3.9
                            </span>
                            <span style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '11px', color: '#475569' }}>
                                <span style={{ display: 'inline-block', width: '14px', height: '14px', backgroundColor: '#ef444422', border: '1px solid #ef4444', borderRadius: '3px' }} />
                                Score &lt; 3.0
                            </span>
                        </div>
                    </>
                )}
            </main>
        </div>
    );
}

export default PesquisaClimaRelatorio;